export default {


//new stage url
////

// API_URL: 'http://65.2.154.47/api_ftl',
// MISREPORT_API_URL:'http://65.2.154.47/api_ftl',
// MIGRATION_API_URL:'http://65.2.154.47/api_ftl'

API_URL: process.env.VUE_APP_API_URL,
MISREPORT_API_URL:process.env.VUE_APP_API_URL,
MIGRATION_API_URL:process.env.VUE_APP_API_URL

// rohan sir
// API_URL: 'http://10.0.14.106:8081/api_ftl',  
// MISREPORT_API_URL:'http://10.0.14.106:8081/api_ftl',
// MIGRATION_API_URL:'http://10.0.14.106:8081/api_ftl'

// pranali - 10.0.13.188
// API_URL: 'http://10.0.13.188:8081/api_ftl',
// MISREPORT_API_URL: 'http://10.0.13.188:8081/api_ftl',
// MIGRATION_API_URL: 'http://10.0.13.188:8081/api_ftl'

//shreyash
// API_URL: 'http://10.0.14.21:8081/api_ftl',
// MISREPORT_API_URL: 'http://10.0.14.21:8081/api_ftl',
// MIGRATION_API_URL: 'http://10.0.14.21:8081/api_ftl'

// nazafat sir

// API_URL: 'http://10.0.14.240:8081/api_ftl',
// MISREPORT_API_URL:'http://10.0.14.240:8081/api_ftl',
// MIGRATION_API_URL:'http://10.0.14.240:8081/api_ftl'
// 10.0.14.240
}
